import { createRouter, createWebHistory } from "vue-router";
import Index from "./../views/IndexHome";
import ProductForm from "../../src/components/reusable/Product/ProductForm";
import PdfContentDetail from "@/components/reusable/Product/PdfContentDetail.vue";
import NotFoundPage from "../components/404NotFound.vue";
import MyExcelScreen from "../../src/components/reusable/myExcel/MyExcelScreen";
import Navbar from "../components/AppBar.vue";
import VueCookies from "vue-cookies";

// import CustomSignIn from "../components/login/CustomSignIn.vue";
// import DateCalendar from "../components/DateFormat.vue";
// import Caraousel from "../views/CaraSearch.vue";
const routes = [
  {
    path: "/power_search",
    component: Index,
    name: "Home",
    meta: {
      title: "Power Search- Competiscan.com",
    },
  },
  {
    path: "/productdetail",
    component: ProductForm,
    name: "ProductForm",
    meta: {
      title: "Power Search- Competiscan.com",
    },
    beforeEnter: (to, from, next) => {
      console.log("cookies value", VueCookies.get("competiscaner"));
      const cookieVal = VueCookies.get("competiscaner");
      // const urlParams = new URLSearchParams(window.location.search);

      if (cookieVal) {
        if (to.name !== "ProductForm") {
          next({ name: "ProductForm" });
        } else {
          next();
        }
      } else {
        VueCookies.set(
          "lastURL",
          window.location.href,
          null,
          null,
          ".competiscan.com"
        );
        window.location.href = "https://competiscan.com/login.php";
      }
    },
  },
  {
    path: "/myexcel",
    components: {
      default: MyExcelScreen,
      navbar: Navbar,
    },
    name: "MyExcel",
  },
  {
    path: "/pdfcontentdetail",
    component: PdfContentDetail,
    name: "PdfContentDetail",
    meta: {
      title: "Power Search- Competiscan.com",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFoundPage,
    name: "NotFoundPage",
    meta: { layout: "none-layout" },
  },
  // {
  //   path: "/CustomSignIn",
  //   component: CustomSignIn,
  //   name: "signin",
  //   props: true,
  //   meta: {
  //     title: "Login - Competiscan.com",
  //   },
  // },
  // {
  //   path: "/DateCalendar",
  //   component: DateCalendar,
  //   name: "Date",
  //   meta: {
  //     title: "Date",
  //   },
  // },
  // {
  //   path: "/caraSearch",
  //   component: Caraousel,
  //   name: "Caraousel",
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
